import React, { useContext, useMemo } from "react";
import MonthButton from "./MonthButton";
import { AppContext } from "../../../AppContext";
import "./MonthNavigator.css";

const NUMBER_OF_MONTHS_TO_DISPLAY = 8;
const MONTH_LOOKUP = {
    1: "ינואר",
    2: "פברואר",
    3: "מרץ",
    4: "אפריל",
    5: "מאי",
    6: "יוני",
    7: "יולי",
    8: "אוגוסט",
    9: "ספטמבר",
    10: "אוקטובר",
    11: "נובמבר",
    12: "דצמבר"
};

export default function MonthNavigator() {
    const { selectedMonthId, selectedYear, setSelectedYear, setSelectedMonthId } = useContext(AppContext);

    const selectedItem = `${selectedYear}-${selectedMonthId}`;

    const onMonthClick = (month) => {
        const parts = month.split("-");
        setSelectedMonthId(parts[1]);
        setSelectedYear(parts[0]);
    };

    const { months, currentMonthKey } = useMemo(() => {
        const months = {};
        const now = new Date();
        let year = now.getFullYear();
        let month = now.getMonth() + 1;
        const currentMonthKey = `${year}-${month}`;

        for (let i = 0; i < NUMBER_OF_MONTHS_TO_DISPLAY; i++) {
            const key = `${year}-${month}`;
            months[key] = `${year.toString().substring(2, 4)} ${MONTH_LOOKUP[month]}`;
            month -= 1;
            if (month === 0) {
                month = 12;
                year -= 1;
            }
        }

        return { months, currentMonthKey };
    }, []);

    return (
        <div className="month-navigator">
            <div className="month-navigator__scroll-area">
                {Object.keys(months).map((month) => (
                    <MonthButton
                        key={month}
                        monthIndex={month}
                        monthDescription={months[month]}
                        selected={selectedItem === month}
                        isCurrent={month === currentMonthKey}
                        monthSelected={onMonthClick}
                    />
                ))}
            </div>
        </div>
    );
}
